import { measuredUsingConfigFor as wrap } from 'Components/Worksheets/Core/Helpers/configHelpers';

//defines which balance is used for which masses.
const getMeasuredUsingConfig = (prefix: string) => {
  const balance = wrap(`${prefix}.Equipment.Balance`);
  return {
    [`${prefix}.TotalMaterialDryMass`]: balance,
    [`${prefix}.Sieves.WetMassRetained`]: balance,
    [`${prefix}.Sieves.DryMassRetained`]: balance,
    [`${prefix}.Sieves.WetMassPassing`]: balance,
    [`${prefix}.TotalMaterial.TareMass`]: balance,
    [`${prefix}.TotalMaterial.WetSoilAndTareMass`]: balance,
    [`${prefix}.CoarseMaterial.TareMass`]: balance,
    [`${prefix}.CoarseMaterial.WetSoilAndTareMass`]: balance,
    [`${prefix}.CoarseMaterial.DrySoilAndTareMass`]: balance,
    [`${prefix}.PassingMaterial.TareMass`]: balance,
    [`${prefix}.PassingMaterial.WetSoilAndTareMass`]: balance,
    [`${prefix}.PassingMaterial.DrySoilAndTareMass`]: balance,
  };
};

export default getMeasuredUsingConfig;
